<template>
  <div :class="['rc-textarea-runtime', {'view-style-textarea': disabled}, getClassByCopy]">
    <el-form-item :prop="getProp" :rules="rules"  :class="{'to-left':component.properties.sortType==='toLeft','hidden':component.properties.sortType==='hidden'}" :label="component.properties.sortType==='hidden' ? '' : component.name" label-width="none" ref="elFormItem">
      <el-tooltip class="component-explain-tooltip" :style="{left:tooltipLeft}" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input
        :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
        :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%',marginLeft:textareaMarginLeft}"
        :autosize="disabled && component.properties.heightAdaptation"
        ref="textarea"
        type="textarea"
        :title="getComponentValue||component.properties.placeholder"
        :value="getComponentValue"
        @input="setValue"
        :disabled="disabled || component.properties.readonly"
        :placeholder="component.properties.placeholder"
        @focus="executeFunctions('focus')"
        @blur="validateFormItem"/>
    </el-form-item>
  </div>
</template>

<script>
import { componentMixin, inputMixin, calculationMixin, defaultValueMixin } from './mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
import { textHeight } from '@utils'
export default {
  name: 'rc-textarea',
  mixins: [componentMixin, inputMixin, calculationMixin, defaultValueMixin, heightMixin],
  props: {
    component: Object,
    value: {
      default: ''
    },
    index: [Number, String],
    disabled: Boolean
  },
  inject: ['initCount'],
  mounted () {
    if (!this.component.properties.heightAdaptation) {
      this.initHeight(this.$refs.textarea.$el.children[0])
    }
  },
  data () {
    return {
      tempValue: '',
      state: false,
      firstCreated: true
    }
  },
  computed: {
    getComponentValue () {
      if (this.component.archive.enable) {
        if (this.tempValue || (this.tempValue === '' && this.state === true)) {
          return this.tempValue
        } else {
          return this.value
        }
      } else {
        return this.tempValue
      }
    },
    tooltipLeft () {
      if (this.component.properties.sortType === 'toLeft') {
        return '8px'
      }
    },
    textareaMarginLeft () {
      if (this.component.properties.sortType === 'toLeft' && this.component.properties.componentExplain) {
        return '-2px'
      }
    }
  },
  methods: {
    setValue (val) {
      this.tempValue = val
      this.updateValue(val)
      this.state = true
    },
    updateValue (val) {
      // 归档控件才更新归档值
      if (this.component.archive.enable) {
        val = val === ' ' ? ' ' : val.trim()
        this.update(val)
        // 触发值改变事件
        this.$nextTick(() => this.executeFunctions('change'))
      }
    }
  },
  watch: {
    value (val) {
      // 定制需要直接改dataService的值,在归档情况下才行
      if (this.component.archive.enable) {
        this.tempValue = val
      }
      // 开启高度自适应，并且是在编辑页
      if (this.firstCreated && val && this.component.properties.heightAdaptation && !this.disabled) {
        const height = textHeight(this.$refs.textarea.$el.offsetWidth + 'px', val)
        const defaultHeight = this.$refs.textarea.$el.offsetHeight
        this.$refs.textarea.$el.children[0].style.height = height > defaultHeight ? (height + 5) + 'px' : defaultHeight
        this.firstCreated = false
      }
    }
    // 'initCount.value' (val) {
    //   if (val > 0) {
    //     this.$set(this, 'tempValue', '')
    //   }
    // }
  }
}
</script>
<style lang="scss">
 .layout-form .list-component-item  .rc-textarea-runtime {
    height: calc(100% - 30px);
    div {
      height: 100%;
    }
    .el-form-item {
      .el-form-item__content .component-explain-tooltip {
        position: relative;
        left: -7px;
        top: 0px;
      }
      .el-form-item__content {
        padding-left: 2px;
      }
    }
   .el-form-item.hidden {
     .el-form-item__content .component-explain-tooltip {
       position: absolute;
       left: -7px;
       top: 18px;
     }
     .el-form-item__content {
       display: flex;
       padding-left: 10px;
     }
   }

   .el-form-item.to-left {
     display: flex;
     align-items: center;
     .el-form-item__content .component-explain-tooltip {
       position: relative;
       left: 14px;
       top: 0px;
     }
     .el-form-item__label{
       overflow: unset;
     }
     .el-form-item__content {
       width: 100%;
       display: flex;
       align-items: center;
       padding-left: 2px;
       .el-textarea{
         height: 100%;
         margin-left: 30px;
         color: #363636;
         font-family: Arial;
       }
     }
   }
    .el-textarea ,textarea {
      height: 100%;
      color: #363636;
      font-family: Arial;
    }
    .el-textarea.is-disabled .el-textarea__inner {
      color: #363636;
    }
  }
  .rc-textarea-runtime.view-style-textarea{
    .el-textarea ,textarea{
      font-size: 12px;
      font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-textarea.vue